// Shared constants for role preview mode.

// window.name of the preview iframe. The app enters preview mode only inside a frame with this name.
export const PREVIEW_FRAME_NAME = 'lc-role-preview';

// The profile the preview runs as. Fictional; matches the fixtures.
export const PREVIEW_PROFILE_ID = '0123456789abcdef0123456789abcdef';
export const PREVIEW_PROFILE_NAME = 'Brightside Coffee';
